import HTMLElement from '../html-element/HTMLElement.js';
/**
 * HTMLSpanElement
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLSpanElement
 */
export default class HTMLSpanElement extends HTMLElement {}
